export class NewPass {
  Code: String;
  Password: String;
  PasswordConfirm: String;
}
